var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _path7, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHubspotApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 83,
    viewBox: "0 0 211 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6482 38.9536L80.3057 28.108L79.4836 26.7123L85.6638 16.1914H99.9999L86.6482 38.9536ZM86.6552 44.7785L99.5007 66.6699H85.0914L79.4836 57.0935L80.3057 55.6908L86.6552 44.7785Z",
    fill: "url(#paint0_linear_14053_17097)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2411 51.678L78.1468 53.5599L77.7785 54.1936L77.7593 54.2252L72.0696 64.007L64.7584 76.4854H50.3508L56.1278 66.6684H56.0562L70.6087 41.9348L58.4456 21.2336L49.7783 6.48535H64.186L69.8914 16.1917L77.7785 29.6039L84.9466 41.8628L79.2411 51.678Z",
    fill: "url(#paint1_linear_14053_17097)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8316 66.668V16.193H0V66.668H12.8316Z",
    fill: "url(#paint2_linear_14053_17097)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9758 28.3061V16.1912H20.717V66.668H52.618V54.625H33.5487V47.631H50.8256V35.7338H33.5487V28.3061H52.9758Z",
    fill: "url(#paint3_linear_14053_17097)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.405 27.3191V17.4383C195.029 16.1924 196.712 13.5219 196.726 10.5807V10.3538C196.726 6.15206 193.371 2.74462 189.232 2.74462H189.009C184.87 2.74462 181.514 6.15094 181.514 10.3538V10.5807C181.527 13.5231 183.21 16.1935 185.835 17.4383V27.3191C182.139 27.8943 178.658 29.4503 175.744 31.8298L149.055 10.7234C149.246 10.0257 149.345 9.30897 149.356 8.58883C149.365 3.85459 145.592 0.00900343 140.929 1.57864e-05C136.266 -0.00897186 132.478 3.82089 132.469 8.55513C132.46 13.2894 136.233 17.135 140.896 17.1439C140.898 17.1439 140.899 17.1439 140.901 17.1439C142.362 17.1372 143.796 16.7406 145.06 15.9958L171.341 36.7595C166.509 44.1698 166.639 53.8281 171.667 61.1036L163.673 69.2217C163.027 69.0117 162.354 68.9004 161.676 68.8914C157.847 68.8948 154.746 72.0472 154.747 75.9333C154.747 79.8193 157.851 82.9695 161.68 82.9706C165.509 82.9706 168.613 79.8227 168.616 75.9366C168.607 75.2479 168.498 74.5649 168.291 73.9088L176.198 65.8772C183.263 71.4001 192.968 71.8753 200.526 67.0703C208.082 62.2642 211.897 53.1923 210.085 44.3271C208.275 35.4619 201.222 28.6773 192.406 27.3191M189.127 59.815C183.087 59.9802 178.059 55.1426 177.897 49.0108C177.734 42.879 182.499 37.774 188.538 37.6088C188.734 37.6032 188.931 37.6032 189.127 37.6088C195.014 37.8178 199.681 42.7228 199.685 48.7041C199.687 54.6842 195.025 59.5948 189.138 59.8094",
    fill: "#FF7A59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.624 50.6745C107.071 51.0736 107.071 51.8971 107.624 52.2962L119.915 61.1666C120.576 61.6439 121.5 61.1714 121.5 60.3558L121.5 42.6149C121.5 41.7993 120.576 41.3268 119.915 41.8041L107.624 50.6745Z",
    fill: "#FF7A59"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 5,
    rx: 1,
    transform: "matrix(-1 0 0 1 133.5 48.9854)",
    fill: "#FF7A59"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 5,
    rx: 1,
    transform: "matrix(-1 0 0 1 141.5 48.9854)",
    fill: "#FF7A59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.376 31.6745C141.929 32.0736 141.929 32.8971 141.376 33.2962L129.085 42.1666C128.424 42.6439 127.5 42.1714 127.5 41.3558L127.5 23.6149C127.5 22.7993 128.424 22.3268 129.085 22.8041L141.376 31.6745Z",
    fill: "#5A3293"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 29.9854,
    width: 14,
    height: 5,
    rx: 1,
    fill: "#5A3293"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 107.5,
    y: 29.9854,
    width: 5,
    height: 5,
    rx: 1,
    fill: "#5A3293"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14053_17097",
    x1: 89.7409,
    y1: 66.6699,
    x2: 89.7409,
    y2: 16.1914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14053_17097",
    x1: 70.504,
    y1: 75.4671,
    x2: 58.0119,
    y2: 5.02509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#5F11EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#5A3293"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14053_17097",
    x1: 6.41581,
    y1: 66.668,
    x2: 6.41581,
    y2: 16.1912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14053_17097",
    x1: 36.8456,
    y1: 66.668,
    x2: 36.8456,
    y2: 16.1912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 70,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 76.4854)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHubspotApp);
export default __webpack_public_path__ + "static/media/icon-hubspot-app.43932413a360a1777647294a6a197143.svg";
export { ForwardRef as ReactComponent };